import { Button } from "@material-ui/core";
import { Alert, Backdrop, Box, CircularProgress, CssBaseline, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Paper, Select, Snackbar, Stack, TextField, Toolbar, styled } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import CamIcon from "@mui/icons-material/CameraAlt"
import { API_URL } from "../../Constants";
import { axiosClient, axiosClientCloud } from "../AxiosClient";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonImage = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#ffff',
    color: '#161e55',
    margin: '0px 1rem',
    border: '1px solid rgba(11, 10, 10, 0.17)',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
})

const TextMessage =  styled(FormHelperText)({
    color: 'green'
})

const TextError = styled(TextMessage)({
    color: 'red'
})

const urlApi = API_URL;

export default function Creditos(){
    const [commerces, setCommerces] = useState([]);
    const [sectoresOcupacion, setSectoresOcupacion] = useState([]);
    const [agesRanges, setAgesRanges] = useState([]);
    const fileAuthorization = useRef(null);
    const fileDocumentTop = useRef(null);
    const fileDocumentBack = useRef(null);
    const fileSelfie = useRef(null);
    const [fechaOriginacion, setFechaOriginacion] = useState();
    const [nameClient, setNameClient] = useState("");
    const [numberDocument, setNumberDocument] = useState("");
    const [lastNameClient, setLastNameClient] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [ocupacion, setOcupacion] = useState("");
    const [sectorOcupacion, setSectorOcupacion] = useState("");
    const [gender, setGender] = useState("");
    const [ageRange, setAgeRange] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState();
    const [fechaExpedicion, setFechaExpedicion] = useState();
    const [direccion, setDireccion] = useState("");
    const [ciudad, setCiudad] = useState("");
    const [lugarExpedicionCedula, setLugarExpedicionCedula] = useState("");
    const [idComercio, setIdComercio] = useState("");
    const [ingresos, setIngresos] = useState();
    const [score, setScore] = useState();
    const [totalCuotas, setTotalCuotas] = useState();
    const [maxBucketMora, setMaxBucketMora] = useState("");
    const [valorCredito, setValorCredito] = useState();
    const [valorCuota, setValorCuota] = useState("");
    const [isFileAuthorization, setIsFileAuthorization] = useState(false);
    const [isFileDocumentTop, setIsFileDocumentTop] = useState(false);
    const [isFileDocumentBack, setIsFileDocumentBack] = useState(false);
    const [isFileSelfie, setIsFileSelfie] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const [isSnackbar, setIsSnackbar] = useState(false);
    const [severity, setSeverity] = useState("");
    const [message, setMessage] = useState("");
    const [tarifa, setTarifa] = useState();
    const [interes, setInteres] = useState();
    const [numeroCuotas, setNumeroCuotas] = useState("");
    const [valorSvd, setValorSvd] = useState();
    const [fechaDesembolso, setFechaDesembolso] = useState();
    const [seguroDesempleo, setSeguroDesempleo] = useState();
    const cuotas = Array.from({length: 11}, (_, index) => index+2)
    const tarifas = [
        {
            "tarifa": "4%",
            "valor": 0.04
        },
        {
            "tarifa": "5%",
            "valor": 0.05
        },
        {
            "tarifa": "6%",
            "valor": 0.06
        },
        {
            "tarifa": "personalizado",
            "valor": "valorNuevo"
        }
    ]
    const svd = [
        {
            "tarifa": "0.023%",
            "valor": 0.00023
        },
        {
            "tarifa": "personalizado",
            "valor": "valorNuevo"
        }
    ]
    const seguroDesempleoOptions = [
        {
            "tarifa": "2%",
            "valor": 0.02
        },
        {
            "tarifa": "personalizado",
            "valor": "valorNuevo"
        }
    ]
    const generos = [
        {
            "id": "F",
            "name": "Femenino"
        },
        {
            "id": "M",
            "name": "Masculino"
        }
    ]
    const ocupaciones = [
        {
            "id": "EMPLEADO",
            "name": "Empleado"
        },
        {
            "id": "INDEPENDIENTE",
            "name": "Independiente"
        },
        {
            "id": "PENSIONADO",
            "name": "Pensionado"
        }
    ]
    const [interest, setInterest] = useState([{"tarifa": "personalizado", "valor": "valorNuevo"}]);
    const valorCustom = {"tarifa": "valorNuevo", "svd": "valorNuevo", "interest": "valorNuevo", "seguroDesempleo": "valorNuevo"}
    const [isErrorTarifa, setIsErrorTarifa] = useState(false)
    const [isValorTarifa, setIsValorTarifa] = useState(false)
    const [isValorSvd, setIsValorSvd] = useState(false)
    const [isErrorValorSvd, setIsErrorValorSvd] = useState(false)
    const [isValorInterest, setIsValorInterest] = useState(false)
    const [isErrorValorInterest, setIsErrorValorInterest] = useState(false)
    const [isValorSeguroDesempleo, setIsValorSeguroDesempleo] = useState(false)
    const [isErrorSeguroDesempleo, setIsErrorSeguroDesempleo] = useState(false)
    
    const handleChangeFechaOriginacion = (value) => {
        setFechaOriginacion(value)
    }

    const handleChangeNameClient = (event) => {
        setNameClient(event.target.value)
    }

    const handleChangeNumberDocument = (event) => {
        setNumberDocument(event.target.value)
    }

    const handleChangeLastNameClient = (event) => {
        setLastNameClient(event.target.value)
    }

    const handleChangeCellphone = (event) => {
        setCellphone(event.target.value)
    }

    const handleChangeOcupation = (event) => {
        setOcupacion(event.target.value)
    }

    const handleChangeSectorOcupacion = (event) => {
        setSectorOcupacion(event.target.value)
    }

    const handleChangeFechaNacimiento = (value) => {
        setFechaNacimiento(value)
    }

    const handleChangeFechaExpedicion = (value) => {
        setFechaExpedicion(value)
    }

    const handleChangeGender = (event) => {
        setGender(event.target.value)
    }

    const handleChangeAgeRange = (event) => {
        setAgeRange(event.target.value)
    }

    const handleChangeDireccion = (event) => {
        setDireccion(event.target.value)
    }

    const handleChangeCiudad = (event) => {
        setCiudad(event.target.value)
    }

    const handleChangeLugarExpedicionCedula = (event) => {
        setLugarExpedicionCedula(event.target.value)
    }

    const handleChangeIdComercio = (event) => {
        setIdComercio(event.target.value)
    }

    const handleChangeIngresos = (event) => {
        setIngresos(event.target.value)
    }

    const handleChangeScore = (event) => {
        setScore(event.target.value)
    }

    const handleChangeTotalCuotas = (event) => {
        setTotalCuotas(event.target.value)
    }

    const handleChangeTarifa = (event) => {
        if(event.target.value == valorCustom.tarifa) {
            setIsValorTarifa(true)
            setTarifa("")
        } else {
            setIsValorTarifa(false)
            setIsErrorTarifa(false)
            setTarifa(event.target.value)
        }
    }

    const handleChangeInterest = (event) => {
        if(event.target.value == valorCustom.interest) {
            setIsValorInterest(true)
            setInteres("")
        } else {
            setIsValorInterest(false)
            setIsErrorValorInterest(false)
            setInteres(event.target.value)
        }
    }

    const handleChangeDesembolso = (value) => {
        setFechaDesembolso(value)
    }

    const handleChangeValueInterest = (event) => {
        let regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            const valor = Number(event.target.value.replace("%", ""))/100
            if(valor || valor==0){
                setInteres(valor.toString())
            }
        }
    }

    const handleChangeErrorValueInterest = (event) => {
        const regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            setIsErrorValorInterest(false)
        } else {
            setIsErrorValorInterest(true)
        }
    }

    const handleChangeValueSeguroDesempleo = (event) => {
        let regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            const valor = Number(event.target.value.replace("%", ""))/100
            if(valor || valor==0){
                setSeguroDesempleo(valor.toString())
            }
        }
    }

    const handleChangeErrorValueSeguroDesempleo = (event) => {
        const regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            setIsErrorSeguroDesempleo(false)
        } else {
            setIsErrorSeguroDesempleo(true)
        }
    }

    const handleChangeMaxBucketMora = (event) => {
        setMaxBucketMora(event.target.value)
    }

    const handleChangeValorCredito = (event) => {
        setValorCredito(event.target.value)
    }

    const handleChangeNumeroCuotas = (event) => {
        setNumeroCuotas(event.target.value)
    }

    const handleChangeFileAuthorization = () => {
        if(fileAuthorization?.current?.files?.length>0){
            setIsFileAuthorization(true)
        } else {
            setIsFileAuthorization(false)
        }
    }

    const handleChangeFileDocumentTop = () => {
        if(fileDocumentTop?.current?.files?.length>0){
            setIsFileDocumentTop(true)
        } else {
            setIsFileDocumentTop(false)
        }
    }

    const handleChangeFileDocumentBack = () => {
        if(fileDocumentBack?.current?.files?.length>0){
            setIsFileDocumentBack(true)
        } else {
            setIsFileDocumentBack(false)
        }
    }

    const handleChangeFileSelfie = () => {
        if(fileSelfie?.current?.files?.length>0){
            setIsFileSelfie(true)
        } else {
            setIsFileSelfie(false)
        }
    }

    const handleChangeErrorTarifaFga = (event) => {
        const regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            setIsErrorTarifa(false)
        } else {
            setIsErrorTarifa(true)
        }
    }

    const handleChangeOtraTarifa = (event) => {
        let regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            const valor = Number(event.target.value.replace("%", ""))/100
            if(valor || valor==0){
                setTarifa(valor.toString())
            }
        }
    }

    const handleChangeValorSvd = (event) => {
        if(event.target.value == valorCustom.svd) {
            setIsValorSvd(true)
            setValorSvd("")
        } else {
            setIsValorSvd(false)
            setIsErrorValorSvd(false)
            setValorSvd(event.target.value)
        }
    }

    const handleChangeSvd = (event) => {
        let regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            const valor = Number(event.target.value.replace("%", ""))/100
            if(valor || valor==0){
                setValorSvd(valor.toString())
            }
        }
    }

    const handleChangeValueSvd = (event) => {
        const regex = /^-?\d+(\.\d+)?%$/
        if(regex.test(event.target.value)){
            setIsErrorValorSvd(false)
        } else {
            setIsErrorValorSvd(true)
        }
    }

    const handleChangeSeguroDesempleo = (event) => {
        if(event.target.value == valorCustom.seguroDesempleo) {
            setIsValorSeguroDesempleo(true)
            setSeguroDesempleo("")
        } else {
            setIsValorSeguroDesempleo(false)
            setIsErrorSeguroDesempleo(false)
            setSeguroDesempleo(event.target.value)
        }
    }

    const handleClosedSnack = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setIsSnackbar(false)
    }

    const saveAuthorization = (clientUuid) => {
        const clientRequest = {}
        const imageAuthorization = new FormData()
            imageAuthorization.append("image", fileAuthorization.current.files[0])
            axiosClient.post('/v2/s3/upload/image', imageAuthorization)
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                } else {
                    throw new Error("Error upload images in client");
                }
            })
            .then(message => {
                // Actualizamos los datos del cliente
                clientRequest['dataAuthorization'] = true;
                clientRequest['authorizationUuid'] = message;
                
                return axiosClientCloud.patch(`/v1/clients/${clientUuid}`, clientRequest, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            })
            .then(response => {
                if (response.status === 200) {
                    console.log("Success image authorization");
                } else {
                    console.log("Error with image authorization");
                }
            })
            .catch(error => {
                console.log("Bad request: " + error.message);
            });
    }

    const saveDocumentTop = (clientUuid) => {
        const clientRequest = {}
        const imageDocumentFront = new FormData()
            imageDocumentFront.append("image", fileDocumentTop.current.files[0])
            axiosClient.post('/v2/s3/upload/image', imageDocumentFront)
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                } else {
                    throw new Error("Error upload images in client");
                }
            })
            .then(message => {
                // Actualizamos el cliente con el UUID del documento frontal
                clientRequest['frontDocumentUuid'] = message;

                return axiosClientCloud.patch(`/v1/clients/${clientUuid}`, clientRequest, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            })
            .then(response => {
                if (response.status === 200) {
                    console.log("Success image document top");
                } else {
                    console.log("Error with image document top");
                }
            })
            .catch(error => {
                console.log("Bad request: " + error.message);
            });
    }

    const saveDocumentBack = (clientUuid) => {
        const clientRequest = {}
        const imageDocumentBack = new FormData()
        imageDocumentBack.append("image", fileDocumentBack.current.files[0])
        axiosClient.post('/v2/s3/upload/image', imageDocumentBack)
        .then(response => {
            if (response.status === 200) {
                return response.text();
            } else {
                throw new Error("Error upload images in client");
            }
        })
        .then(message => {
            // Actualizamos el cliente con el UUID del documento posterior
            clientRequest['backDocumentUuid'] = message;
    
            return axiosClientCloud.patch(`/v1/clients/${clientUuid}`, clientRequest, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        })
        .then(response => {
            if (response.status === 200) {
                console.log("Success image document back");
            } else {
                console.log("Error with image document back");
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    const saveSelfie = (clientUuid) => {
        const clientRequest = {}
        const imageSelfie = new FormData()
            imageSelfie.append("image", fileSelfie.current.files[0])
            axiosClient.post('/v2/s3/upload/image', imageSelfie)
            .then(response => {
                if (response.status === 200) {
                    return response.text();
                } else {
                    throw new Error("Error upload images in client");
                }
            })
            .then(message => {
                // Actualizamos el cliente con el UUID del selfie
                clientRequest['selfieUuid'] = message;

                return axiosClientCloud.patch(`/v1/clients/${clientUuid}`, clientRequest, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
            })
            .then(response => {
                if (response.status === 200) {
                    console.log("Success image selfie");
                } else {
                    console.log("Error with image selfie");
                }
            })
            .catch(error => {
                console.log("Bad request: " + error.message);
            });
    }

    const createQuotas = (creditUuid) => {
        const body = {
            status: 'APPROVED'
        }
        axiosClient.patch(`/v1/credits/${creditUuid}/credit-response`, body, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                console.log("Success with create quotas");
            } else {
                console.log("Error with create quotas");
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if(!validateSubmit()){
            return;
        }

        const client = {
            name: nameClient,
            lastName: lastNameClient,
            cellphone: cellphone,
            occupation: ocupacion,
            sectorOccupationuuids: sectorOcupacion,
            birth: fechaNacimiento ? `${dayjs(`${fechaNacimiento?.$d?.getFullYear()}-${fechaNacimiento?.$d?.getMonth()+1}-${fechaNacimiento?.$D}`).format('YYYY-MM-DD')}` : null,
            fechaNacimiento: fechaNacimiento ? dayjs(`${fechaNacimiento?.$d?.getFullYear()}-${fechaNacimiento?.$d?.getMonth()+1}-${fechaNacimiento?.$D}`).format('YYYY-MM-DD') : null,
            dateExpedition: fechaExpedicion ? `${dayjs(`${fechaExpedicion?.$d?.getFullYear()}-${fechaExpedicion?.$d?.getMonth()+1}-${fechaExpedicion?.$D}`).format('DD/MM/YYYY')}` : null,
            gender: gender,
            ageRange: ageRange,
            address: direccion,
            cityAddress: ciudad,
            documentExpeditionPlace: lugarExpedicionCedula,
            estimatedIncome: ingresos == "" ? null : ingresos,
            documentType: 'CC',
            documentNumber: numberDocument
        }

        //Creación del cliente
        axiosClientCloud.post(`/v1/clients`, client, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status) {
                const res = response.data;
                console.log(res);
        
                // Guardar imágenes
                if (fileAuthorization?.current?.files?.length > 0) {
                    saveAuthorization(res.uuid);
                }
        
                if (fileDocumentTop?.current?.files?.length > 0) {
                    saveDocumentTop(res.uuid);
                }
        
                if (fileDocumentBack?.current?.files?.length > 0) {
                    saveDocumentBack(res.uuid);
                }
        
                if (fileSelfie?.current?.files?.length > 0) {
                    saveSelfie(res.uuid);
                }

                //Crear estudio de viabilidad
                let dato = "UP_TO_DATE"
                    
                switch(maxBucketMora){
                    case "0":
                        dato = "UP_TO_DATE"
                        break
                    case "30":
                        dato = "THIRTY"
                        break
                    case "60":
                        dato = "SIXTY"
                        break
                    case "90":
                        dato = "NINETY"
                        break
                    default:
                        dato = "UP_TO_DATE"
                }

                // Generar feasibility
                const feasibility = {
                    client: client,
                    commerceUuid: commerces.filter(commerce => commerce.oldId == idComercio)[0].uuid,
                    status: "PRE_APPROVED"
                };

                axiosClientCloud.post('/v1/feasibility-inquiries', feasibility, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        const dto = response.data;

                        // Generar estudio de viabilidad
                        const viability = {
                            clientUuid: res.uuid,
                            paymentIndicator: score,
                            estimatedIncome: ingresos,
                            bucket: dato,
                            feasibilityInquiryUuid: dto.uuid,
                            totalQuotas: totalCuotas,
                        };

                        axiosClientCloud.post('/v1/viability-studies', viability, {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(response => {
                            if (response.status === 200) {
                                console.log("Success create viability");
                            } else {
                                console.log("Error create viability");
                                console.log(response.data.message);
                            }
                        })
                        .catch(error => {
                            console.log("Bad request: " + error.message);
                        });

                    } else {
                        console.log("Error with feasibility");
                        console.log(response.data.message);
                    }
                })
                .catch(error => {
                    console.log("Error: " + error.message);
                });

                // Crear crédito
                const credit = {
                    totalValue: valorCredito === "" ? null : valorCredito,
                    quotaValue: valorCuota === "" ? null : valorCuota,
                    quotasNumber: numeroCuotas === "" ? null : numeroCuotas,
                    clientUuid: res.uuid,
                    seguroDeVida: valorSvd,
                    seguroDesempleo: seguroDesempleo,
                    commerceUuid: commerces.filter(commerce => commerce.oldId == idComercio)[0].uuid,
                    status: "PENDING",
                    tarifaFga: tarifa,
                    fechaDesembolso: fechaDesembolso ? dayjs(`${fechaDesembolso?.$d?.getFullYear()}-${fechaDesembolso?.$d?.getMonth()+1}-${fechaDesembolso?.$D}`).format('YYYY-MM-DD') : null,
                    interestRate: interes,
                    originDate: fechaOriginacion ? dayjs(`${fechaOriginacion?.$d?.getFullYear()}-${fechaOriginacion?.$d?.getMonth()+1}-${fechaOriginacion?.$D}`).format('YYYY-MM-DD') : null,
                    occupationClient: parseFloat(seguroDesempleo) > 0 ? ocupacion : null
                };

                setIsBackdrop(true);

                axiosClient.post('/v1/credits', credit, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        setIsBackdrop(false);
                        setIsSnackbar(true);
                        setMessage("Se creó exitosamente el crédito");
                        setSeverity("success");
                        setFechaOriginacion(null);
                        setNumberDocument("");
                        setNameClient("");
                        setLastNameClient("");
                        setCellphone("");
                        setOcupacion("");
                        setSectorOcupacion("");
                        setFechaNacimiento(null);
                        setFechaExpedicion(null);
                        setGender("");
                        setAgeRange("");
                        setDireccion("");
                        setCiudad("");
                        setLugarExpedicionCedula("");
                        setIdComercio("");
                        setIngresos("");
                        setScore("");
                        setTotalCuotas("");
                        setMaxBucketMora("");
                        setFechaDesembolso(null);
                        setValorCredito("");
                        setNumeroCuotas("");

                        if (fileAuthorization.current) {
                            fileAuthorization.current.value = '';
                        }
                        if (fileDocumentTop.current) {
                            fileDocumentTop.current.value = '';
                        }
                        if (fileDocumentBack.current) {
                            fileDocumentBack.current.value = '';
                        }
                        if (fileSelfie.current) {
                            fileSelfie.current.value = '';
                        }
                        
                        setIsFileAuthorization(false);
                        setIsFileDocumentTop(false);
                        setIsFileDocumentBack(false);
                        setIsFileSelfie(false);

                        // Crear cuotas
                        createQuotas(response.data.uuid);
                    } else {
                        setIsBackdrop(false);
                        setIsSnackbar(true);
                        setMessage("Error en la creación del crédito");
                        setSeverity("error");
                        console.log("Error:", response.data.message);
                    }
                })
                .catch(error => {
                    setIsBackdrop(false);
                    setIsSnackbar(true);
                    setMessage("Error en la creación del crédito");
                    setSeverity("error");
                    console.log('Error: ' + error.message);
                });
            } else {
                throw new Error("Error in creation client");
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });
    }

    const validateSubmit = () => {
        let isValid = true;
        if(fechaOriginacion == null) {
            isValid = false;
        }
        if(numberDocument == "") {
            isValid = false;
        }
        if(nameClient == "") {
            isValid = false;
        }
        if(lastNameClient == "") {
            isValid = false;
        }
        if(cellphone == "") {
            isValid = false;
        }
        if(ocupacion == "") {
            isValid = false;
        }
        if(sectorOcupacion == "") {
            isValid = false;
        }
        if(fechaNacimiento == null) {
            isValid = false;
        }
        if(fechaExpedicion == null) {
            isValid = false;
        }
        if(gender == "") {
            isValid = false;
        }
        if(ageRange == "") {   
            isValid = false;
        }
        if(direccion == "") {
            isValid = false;
        }
        if(ciudad == "") {
            isValid = false;
        }
        if(lugarExpedicionCedula == "") {
            isValid = false;
        }
        if(!isValid) {
            setIsSnackbar(true);
            setMessage("Por favor, completa todos los campos para continuar");
            setSeverity("error");
        }
        return isValid;
    }

    // console.log(commerces)
    // console.log(score)

    useEffect(() => {
        axiosClient.get('/v1/commerces/all-commerces')
        .then(response => {
            if (response.status === 200) {
                setCommerces(response.data.sort((a, b) => a.oldId - b.oldId));
            } else {
                console.log('Error in fetch');
            }
        })
        .catch(error => {
            console.log("Bad request: " + error.message);
        });

        axiosClient.get('/v1/parameters')
        .then(response => {
            if (response.status === 200) {
                const res = response.data;
                setInterest([{
                    "tarifa": `${(res.interestRate * 100).toFixed(2)}%`, 
                    "valor": res.interestRate
                }, ...interest]);
            } else {
                console.log("Error in fetch");
            }
        })
    .catch(error => {
        console.log("Bad request: " + error.message);
    });

    axiosClientCloud.get('/v1/sector-occupations')
    .then(response => {
        if (response.status === 200) {
            setSectoresOcupacion(response.data);
        } else {
            console.log('Error in fetch');
        }
    });

    axiosClient.get('/v1/ranges-age')
    .then(response => {
        if (response.status === 200) {
            setAgesRanges(response.data);
        } else {
            console.log('Error in fetch');
        }
    });

    }, [])

    useEffect(() => {
        console.log(seguroDesempleo)
        if(valorCredito && totalCuotas && idComercio && interes && valorCredito != "" && seguroDesempleo && totalCuotas!="" && idComercio!="" && tarifa!="" && valorSvd!="" && interes!="" && seguroDesempleo!=""){
            const body = {
                creditValue: valorCredito,
                numberQuotas: numeroCuotas,
                commerceId: idComercio,
                tarifa: tarifa,
                svd: valorSvd,
                interest: interes,
                seguroDesempleo: seguroDesempleo,
                occupationClient: ocupacion
            }

            axiosClient.post('/v1/credits/valueQuota', body, {
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                if (response.status === 200) {
                    setValorCuota(response.data);
                } else {
                    console.log("Error with value quota");
                }
            })
            .catch(error => {
                console.log("Bad request: " + error.message);
            });
        } else {
            setValorCuota("")
        }
    }, [valorCredito,totalCuotas,idComercio,tarifa,valorSvd, numeroCuotas, interes, seguroDesempleo, ocupacion])

    useEffect(() => {
        if(idComercio != null && idComercio != "" && idComercio && fechaOriginacion != null && fechaOriginacion && fechaOriginacion != "") {
            const desembolso = {
                commerceId: idComercio,
                fechaOriginacion: dayjs(`${fechaOriginacion?.$d?.getFullYear()}-${fechaOriginacion?.$d?.getMonth()+1}-${fechaOriginacion?.$D}`).format('YYYY-MM-DD')
            }
            axiosClient.post('/v1/credits/desembolso', desembolso, {
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                if (response.status === 200) {
                    setFechaDesembolso(dayjs(response.data));
                } else {
                    console.log("Error fetch");
                }
            })
            .catch(error => {
                console.log("Error petition: " + error.message);
            });
        }
    }, [idComercio, fechaOriginacion])

    return (
        <React.Fragment>
            <CssBaseline></CssBaseline>
            <Toolbar></Toolbar>
            <Box sx={{width: '100%'}}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container>
                        <Grid item>
                            <Box display={'flex'}>
                                <h1>Creación de créditos</h1>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box container sx={{width:'75vw'}}>
                        <form onSubmit={handleSubmit}>
                            <Box width={'100%'} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de Originación" value={fechaOriginacion} onChange={handleChangeFechaOriginacion}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="numero-identificacion" label="Número de identificación" variant="outlined" value={numberDocument} onChange={handleChangeNumberDocument}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="nombres" label="Nombres cliente" variant="outlined" value={nameClient} onChange={handleChangeNameClient}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="apellidos" label="Apellidos cliente" variant="outlined" value={lastNameClient} onChange={handleChangeLastNameClient}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="numero-celular" label="Número de celular" variant="outlined" value={cellphone} onChange={handleChangeCellphone}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="ocupacion">Ocupación</InputLabel>
                                    <Select labelId="ocupacion" id="select-ocupacion" label="Ocupación" value={ocupacion} onChange={handleChangeOcupation}>
                                        {ocupaciones?.map(items => (
                                            <MenuItem key={items.id} value={items.id}>{`${items.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="sector-ocupacion">Sector Ocupación</InputLabel>
                                    <Select labelId="sector_ocupacion" id="select-sectorOccupation" label="Sector Ocupación" value={sectorOcupacion} onChange={handleChangeSectorOcupacion}>
                                        {sectoresOcupacion?.map(ocupacion => (
                                            <MenuItem key={ocupacion.uuid} value={ocupacion.uuid}>{`${ocupacion.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de nacimiento" value={fechaNacimiento} onChange={handleChangeFechaNacimiento}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de expedición del documento" value={fechaExpedicion} onChange={handleChangeFechaExpedicion}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="genero">Género</InputLabel>
                                    <Select labelId="genero" id="gender" label="Género" value={gender} onChange={handleChangeGender}>
                                        {generos?.map(genero => (
                                            <MenuItem key={genero.id} value={genero.id}>{`${genero.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="rango-edad">Rango edad</InputLabel>
                                    <Select labelId="rango-edad" id="rangoEdad" label="Rango edad" value={ageRange} onChange={handleChangeAgeRange}>
                                        {agesRanges?.map(edades => (
                                            <MenuItem key={edades.range} value={edades.range}>{`${edades.range}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="direccion-residencia" label="Dirección de residencia" variant="outlined" value={direccion} onChange={handleChangeDireccion}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="ciudad-residencia" label="Ciudad/Municipio de residencia" variant="outlined" value={ciudad} onChange={handleChangeCiudad}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="expedicion-documento" label="Lugar de expedición del documento" variant="outlined" value={lugarExpedicionCedula} onChange={handleChangeLugarExpedicionCedula}></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="commerce-id">Id Comercio</InputLabel>
                                    <Select labelId="commerce-id" id="select-commerceId" label="Id Comercio" value={idComercio} onChange={handleChangeIdComercio}>
                                        {commerces?.map(commerce => (
                                            <MenuItem key={commerce.oldId} value={commerce.oldId}>{`${commerce.oldId}. ${commerce.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="ingresos" label="Ingresos estimados finales" variant="outlined" value={ingresos} onChange={handleChangeIngresos}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="score" label="Score" variant="outlined" value={score} onChange={handleChangeScore}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="cuotas" label="Total cuotas" variant="outlined" value={totalCuotas} onChange={handleChangeTotalCuotas}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="numero-cuotas">Número de cuotas</InputLabel>
                                    <Select labelId="numero-cuotas" id="select-numeroCuotas" label="Número de cuotas" value={numeroCuotas} onChange={handleChangeNumeroCuotas}>
                                        {cuotas?.map(numberQuota => (
                                            <MenuItem key={numberQuota} value={numberQuota}>{numberQuota}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="max-bucket" label="Max Bucket mora" variant="outlined" value={maxBucketMora} onChange={handleChangeMaxBucketMora}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="valor-credito" label="Valor crédito" variant="outlined" value={valorCredito} onChange={handleChangeValorCredito}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="tarifa-fga">Tarifa FGA</InputLabel>
                                    <Select labelId="tarifa-fga" id="select-tarifaFga" label="Tarifa FGA" value={tarifa} onChange={handleChangeTarifa}>
                                        {tarifas?.map(tarifaFga => (
                                            <MenuItem key={tarifaFga.valor} value={tarifaFga.valor}>{tarifaFga.tarifa}</MenuItem>
                                        ))}
                                    </Select>
                                    {isValorTarifa && <TextField id="valor-tarifaFga" label="Valor personalizado" placeholder="1.3%" variant="outlined" onChange={handleChangeOtraTarifa} onBlur={handleChangeErrorTarifaFga} sx={{margin: '0.5rem 0'}}></TextField>}
                                </FormControl>
                                {isErrorTarifa && <TextError>El campo debe contener formato de porcentaje, ejemplo 1.3%</TextError>}
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="tarifa-svd">Seguro de vida deudor</InputLabel>
                                    <Select labelId="tarifa-svd" id="select-svd" label="Seguro de vida deudor" value={valorSvd} onChange={handleChangeValorSvd}>
                                        {svd?.map(tarifaSvd => (
                                            <MenuItem key={tarifaSvd.valor} value={tarifaSvd.valor}>{tarifaSvd.tarifa}</MenuItem>
                                        ))}
                                    </Select>
                                    {isValorSvd && <TextField id="valor-svd" label="Valor personalizado" placeholder="1.3%" variant="outlined" onChange={handleChangeSvd} onBlur={handleChangeValueSvd} sx={{margin: '0.5rem 0'}}></TextField>}
                                </FormControl>
                                {isErrorValorSvd && <TextError>El campo debe contener formato de porcentaje, ejemplo 1.3%</TextError>}
                            </Box>
                            <Box width={'100%'} mt={5}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de Desembolso" value={fechaDesembolso} onChange={handleChangeDesembolso}></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="tarifa-interest">Interés</InputLabel>
                                    <Select labelId="tarifa-interes" id="select-interes" label="Interés" value={interes} onChange={handleChangeInterest}>
                                        {interest?.map(tarifaInterest => (
                                            <MenuItem key={tarifaInterest.valor} value={tarifaInterest.valor}>{tarifaInterest.tarifa}</MenuItem>
                                        ))}
                                    </Select>
                                    {isValorInterest && <TextField id="valor-interes" label="Valor personalizado" placeholder="1.3%" variant="outlined" onChange={handleChangeValueInterest} onBlur={handleChangeErrorValueInterest} sx={{margin: '0.5rem 0'}}></TextField>}
                                </FormControl>
                                {isErrorValorInterest && <TextError>El campo debe contener formato de porcentaje, ejemplo 1.3%</TextError>}
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="tarifa-seguro-desempleo">Seguro desempleo</InputLabel>
                                    <Select labelId="tarifa-seguro-desempleo" id="select-seguroDesempleo" label="Seguro desempleo" value={seguroDesempleo} onChange={handleChangeSeguroDesempleo}>
                                        {seguroDesempleoOptions?.map(tarifaSeguroDesempleo => (
                                            <MenuItem key={tarifaSeguroDesempleo.valor} value={tarifaSeguroDesempleo.valor}>{tarifaSeguroDesempleo.tarifa}</MenuItem>
                                        ))}
                                    </Select>
                                    {isValorSeguroDesempleo && <TextField id="valor-seguro-desempleo" label="Valor personalizado" placeholder="1.3%" variant="outlined" onChange={handleChangeValueSeguroDesempleo} onBlur={handleChangeErrorValueSeguroDesempleo} sx={{margin: '0.5rem 0'}}></TextField>}
                                </FormControl>
                                {isErrorSeguroDesempleo && <TextError>El campo debe contener formato de porcentaje, ejemplo 1.3%</TextError>}
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="cuota" label="Valor cuota" disabled value={valorCuota}></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'50%'} mt={5} mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                                {/* <FormControl sx={{width: '65%'}}> */}
                                    <InputLabel id="autorizacion-tratamiento-de-datos" sx={{margin: 'auto 1rem auto'}}>Autorización tratamiento de datos</InputLabel>
                                    <ButtonImage onClick={(e) => fileAuthorization.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileAuthorization} onChange={handleChangeFileAuthorization}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                {/* </FormControl> */}
                            </Box>
                            <Grid width={'50%'}>
                                {isFileAuthorization && <TextMessage sx={{marginLeft: '1rem'}}>Imagen cargada</TextMessage>}
                            </Grid>
                            <Box width={'50%'} mt={5} mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                {/* <FormControl sx={{width: '65%'}}> */}
                                    <InputLabel id="foto-cedula" sx={{margin: 'auto 1rem auto'}}>Foto frontal cédula</InputLabel>
                                    <ButtonImage onClick={(e) => fileDocumentTop.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileDocumentTop} onChange={handleChangeFileDocumentTop}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                {/* </FormControl> */}
                            </Box>
                            <Grid width={'50%'}>
                                {isFileDocumentTop && <TextMessage sx={{marginLeft: '1rem'}}>Imagen cargada</TextMessage>}
                            </Grid>
                            <Box width={'50%'} mt={5} mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                {/* <FormControl sx={{width: '65%'}}> */}
                                    <InputLabel id="foto-cedula-back" sx={{margin: 'auto 1rem auto'}}>Foto trasera cédula</InputLabel>
                                    <ButtonImage onClick={(e) => fileDocumentBack.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileDocumentBack} onChange={handleChangeFileDocumentBack}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                {/* </FormControl> */}
                            </Box>
                            <Grid width={'50%'}>
                                {isFileDocumentBack && <TextMessage sx={{marginLeft: '1rem'}}>Imagen cargada</TextMessage>}
                            </Grid>
                            <Box width={'50%'} mt={5} mb={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                {/* <FormControl sx={{width: '65%'}}> */}
                                    <InputLabel id="foto-selfie" sx={{margin: 'auto 1rem auto'}}>Selfie</InputLabel>
                                    <ButtonImage onClick={(e) => fileSelfie.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileSelfie} onChange={handleChangeFileSelfie}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                {/* </FormControl> */}
                            </Box>
                            <Grid width={'50%'}>
                                {isFileSelfie && <TextMessage sx={{marginLeft: '1rem'}}>Imagen cargada</TextMessage>}
                            </Grid>
                            <Box textAlign={'center'} mb={8} mt={5.7}>
                                <ButtonAdd type="submit">Crear crédito</ButtonAdd>
                            </Box>
                        </form>
                    </Box>
                </Stack>
            </Box>
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={isBackdrop}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={isSnackbar} autoHideDuration={5000} onClose={handleClosedSnack}>
                <Alert onClose={handleClosedSnack} severity={severity} sx={{width: '100%'}}>{message}</Alert>
            </Snackbar>
        </React.Fragment>
        
    )
}